import { Modal, Form, Button } from "react-bootstrap";
import { useState, useEffect, useContext, useMemo } from "react";
import DatePiker from "../../datepiker/datePiker";
import useAxios from "../../../services/useAxios";
import AuthenticationContext from "../../../Authentication/AuthenticationContext.ts";
import { CustomInput, ReactSelect } from "../../kits/Inputs/Inputs";
import OrderItems from "../../addAndEditOrder/OrderItemes";
import { translateToReactSelect } from "../../../utils/helperFunction";

import CustomButton from "../../kits/button/CustomButton";

import {
  showSwalQuestion,
  showSwalSuccess,
  showSwalError,
} from "../../../utils/swal";
import Select from "react-select";
import ToastCustomize from "../../kits/ToastCustomize";
import { addCommas } from "@persian-tools/persian-tools";
import CheckPriceComponent from "../../check-price/CheckPriceComponent";
export default function CallPriceNew({
  show,
  setShow,
  sendHandler,
  dataCheckPrice,
  setDataCheckPrice,
  priceCheckPrice,
  setPriceCheckPrice,
  reset,
}) {
  const { userInfo } = useContext(AuthenticationContext);

  const handleClose = () => setShow(false);
  const { execute: addLeadStep } = useAxios("api/chat_add_lead_step_linkd");
  const add = (date, text) => {};
  const { execute: getProduct } = useAxios("api2/product_list");
  const { execute: findFabrics } = useAxios("api/Find_Fabrics");

  const [data, setData] = useState({
    data: {},
    height: "",
    garamaj: "",
    pieces: "",
    piecesData: [],
    width: "",
    price: 0,
    count: 0,
    discount: 0,
  });

  const inputHandler = (data, name) => {
    setData((prev) => {
      return { ...prev, [name]: data };
    });
  };
  const [product, setProduct] = useState([]);
  const [allFabrics, setAllFabrics] = useState([]);
  const reduceTwoArray = (bigArray, smallArray) => {
    let a = bigArray.filter((b) => !smallArray.find((s) => b.value == s.value));
    return a;
  };
  async function getProductFun() {
    let tempFormulationList = [];
    await getProduct({}).then((result) => {
      let temp = result.products?.filter((v) => [1, 2].includes(+v.main_type));

      let temp1 = reduceTwoArray(
        translateToReactSelect(false, temp, "title", true),
        tempFormulationList
      );
      let temp2 = temp1.map((value) => {
        return {
          ...value,
          order_options: value.order_options?.map((val) => {
            return {
              ...val,
              value: val.value?.map((v) => {
                return {
                  ...v,
                  value: { ...JSON.parse(v.value), checked: false },
                };
              }),
            };
          }),
          product_options: value.product_options?.map((v) => {
            return {
              ...v,
              checked: false,
            };
          }),
        };
      });

      setProduct(temp2);
    });
  }

  const productList = useMemo(
    () =>
      // +fullInfo.type === 1
      //   ? product.filter((v) => +v.main_type === 2)
      // :
      product.filter((v) => +v.main_type === 1),
    [
      // fullInfo.type,
      product,
    ]
  );
  const checkData = (a, dataId, valueId, valueType, e) => {
    let temp = { ...data };
    let test = {
      ...data,
      piecesData: [
        {
          ...temp.piecesData[0],
          datas: data.piecesData?.[0]?.datas?.map((val) => {
            if (val?.id == valueId) {
              return {
                ...val,
                value: val.type === "select" ? e?.value : e?.target?.value,
              };
            } else return val;
          }),
        },
      ],
    };
    setData(test);
    console.log(
      "test2",
      test
      // e,
      // valueType,
      // temp.filter((v) => v.id == valueId)
      // data,
      // a,
      // dataId,
      // valueId,
      // valueType,
      // e.label != undefined ? e : e.target.value
    );
  };
  const SendMassage = () => {
    let chap = "";
    dataCheckPrice?.additionalPrice?.filter((v) => {
      if (v.checked && v.needNumber) {
        if (v?.more_option && v?.more_option.length > 0) {
          chap += `${v.title} - ${v.count} ضرب چاپ - ${
            v?.more_option_value == 1
              ? "یک طرفه"
              : v?.more_option_value == 2
              ? "دوطرفه"
              : ""
          }  - ${addCommas(v.price)} تومان 
        `;
        } else {
          chap += `${v.title} - ${v.count} ضرب چاپ - ${addCommas(
            v.price
          )} تومان 
        `;
        }
      } else if (v.checked && !v.needNumber) {
        chap += `${v.title} - ${addCommas(v.price)} تومان 
        `;
      }
    });
    let finaltxt =
      `${dataCheckPrice?.type?.label} 
    عرض : ${dataCheckPrice?.atf} 
    قد :  ${dataCheckPrice?.ghad} 
    گرماژ: ${dataCheckPrice?.garamaj} گرم
    قیمت : ${addCommas(priceCheckPrice)} تومان
    ` + chap;
    // console.log("object final txt", finaltxt);
    sendHandler([], finaltxt);
  };
  const changeDataCheckPriceFun = (object, type = "normal", id = 0) => {
    if (type == "normal") {
      setDataCheckPrice((prev) => {
        return { ...prev, ...object };
      });
    } else if (type == "checkbox") {
      let arrayCheckTemp = dataCheckPrice?.additionalPrice?.map((v) => {
        if (v.id == id) {
          return { ...v, checked: !v.checked };
        } else return v;
      });

      setDataCheckPrice((prev) => {
        return { ...prev, additionalPrice: arrayCheckTemp };
      });
    } else if (type == "countCheckbox") {
      let arrayCheckTemp = dataCheckPrice.additionalPrice.map((v) => {
        if (v.id == id) {
          return { ...v, ...object };
        } else return v;
      });
      setDataCheckPrice((prev) => {
        return { ...prev, additionalPrice: arrayCheckTemp };
      });
    }
  };
  useEffect(() => {
    findFabrics().then((res) => {
      setAllFabrics(res.map((val) => ({ label: val.title, value: val.id })));
    });
    getProductFun();
  }, []);
  // console.log("object", data);
  return (
    <>
      <Modal size="lg" show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>استعلام قیمت</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <CheckPriceComponent
            data={dataCheckPrice}
            changeData={changeDataCheckPriceFun}
            price={priceCheckPrice}
            setPrice={setPriceCheckPrice}
            reset={reset}
          />
          <div className="d-flex justify-content-end mt-2">
            <CustomButton
              className="mx-2"
              onClick={() => {
                SendMassage();
                // if (data.count > 0) {
                //   if (data.price == 0) {
                //     ToastCustomize({
                //       mainText: "ابتدا استعلام قیمت را بزنید.",
                //       duration: 2000,
                //       toastType: "danger",
                //       color: "danger",
                //       position: "top-center",
                //       hasHeader: false,
                //     });
                //   } else SendMassage();
                // } else
                //   ToastCustomize({
                //     mainText: "اطلاعات وارد شده ناقص است.",
                //     duration: 2000,
                //     toastType: "danger",
                //     color: "danger",
                //     position: "top-center",
                //     hasHeader: false,
                //   });
              }}
              color="success"
            >
              ارسال
            </CustomButton>
            <CustomButton className="" onClick={handleClose} color="danger">
              انصراف
            </CustomButton>
          </div>
        </Modal.Body>
        {/* <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            لغو
          </Button>
          <Button variant="primary" onClick={() => {}}>
            ارسال
          </Button>
        </Modal.Footer> */}
      </Modal>
    </>
  );
}
